/**
 * API Error Handler Service
 * Centralized error handling and status code mapping
 */
export class ApiErrorHandler {
  /**
   * Map HTTP status codes to user-friendly error messages
   */
  getErrorMessage(status: number): string {
    const errorMap: Record<number, string> = {
      400: '请求参数错误',
      401: '未授权，请重新登录',
      403: '拒绝访问',
      404: '请求地址不存在',
      500: '服务器内部错误',
      502: '网关错误',
      503: '服务不可用',
      504: '网关超时',
    };

    return errorMap[status] || `请求失败 (${status})`;
  }

  /**
   * Determine if authentication should be cleared based on status code
   */
  shouldClearAuth(status: number): boolean {
    return status === 401;
  }
}

// Export singleton instance
export const errorHandler = new ApiErrorHandler();

